<template>
  <div class="px-5">
    <v-col cols="12" class="py-0 group-bread-scrumb">
        <router-link :to="{name: 'Campaign'}">
          Quản lý chiến dịch
        </router-link>
        <span> > </span>
        <router-link v-if="!campaign.id" :to="{name: 'CreateCampaign'}">
          Thêm mới chiến dịch
        </router-link>
        <router-link v-if="campaign.id" :to="{name: 'UpdateCampaign'}">
          Chỉnh sửa chiến dịch
        </router-link>
    </v-col>
    <div class="create-form">
      <validation-observer ref="validator">
        <v-col cols="12">
          <div class="justify-end d-flex">
            <v-btn
              v-if="campaign.id && campaign.status === campaignStatusPending"
              class="btn-save btn-green"
              small
              @click="approveCampaign"
              :disabled="isPending"
            >
              <span>Duyệt chiến dịch</span>
            </v-btn>

            <v-btn
              v-if="campaign.id && campaign.status === campaignStatusPending"
              class="btn-save btn-red"
              small
              @click="cancelCampaign"
              :disabled="isPending"
            >
              <span>Hủy chiến dịch</span>
            </v-btn>

            <v-btn
              v-if="campaign.id && campaign.status === campaignStatusActive"
              class="btn-save btn-red"
              small
              @click="stopCampaign"
              :disabled="isPending"
            >
              <span>Ngừng hoạt động</span>
            </v-btn>

            <v-btn
              class="btn-save"
              small
              @click="saveCampaign"
              :disabled="isPending"
              v-if="!campaign.id"
            >
              <span>Lưu</span>
            </v-btn>

            <v-btn
              class="btn-save"
              small
              @click="saveCampaign"
              :disabled="isPending"
              v-if="canUpdate"
            >
              <span>Lưu</span>
            </v-btn>

            <v-btn
              class="btn-cancel mx-0"
              small
              @click="cancel"
            >
              Quay lại
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12">
          <div class="group-form">
            <v-row>
              <v-col cols="12" class="py-0 pt-2 px-8">
                <h3>Thông tin cơ bản</h3>
              </v-col>
              <v-col cols="3" class="px-8 py-0 pt-2">
                <p class="text-bold mb-1">Tên chiến dịch*</p>
                <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  :rules="{ required: true}"
                  name="Tên chiến dịch"
                >
                  <v-text-field
                    class="text-field"
                    :error-messages="errors"
                    placeholder="Vui lòng nhập tên chiến dịch"
                    outlined
                    dense
                    maxLength="50"
                    :disabled="isDisableActive"
                    v-model="campaign.title"
                  ></v-text-field>
                </validation-provider>
              </v-col>
              <v-col cols="3" class="px-8 py-0 pt-2">
                <p class="text-bold mb-1">Mã chiến dịch</p>
                {{ campaign.code || '--'}}
              </v-col>
              <v-col cols="3" class="px-8 py-0 pt-2">
                <p class="text-bold mb-1">Mô tả</p>
                <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  :rules="{}"
                  name="Mô tả"
                >
                  <v-text-field
                    class="text-field"
                    :error-messages="errors"
                    placeholder="Nhập mô tả chiến dịch"
                    outlined
                    dense
                    maxLength="255"
                    :disabled="isDisableActive"
                    v-model="campaign.description"
                  ></v-text-field>
                </validation-provider>
              </v-col>
              <v-col cols="3" class="px-8 py-0 pt-2">
                <p class="text-bold mb-1">Trạng thái</p>
                {{ (campaign.status) ? statusObj[campaign.status] : '--' }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3" class="px-8 py-0">
                <p class="text-bold mb-1">Áp dụng từ ngày*</p>
                <v-menu
                  ref="startDate"
                  v-model="startDate"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  :disabled="isDisablePending"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <validation-provider
                      v-slot="{ errors }"
                      :rules="{ required: true}"
                      name="Từ ngày">
                      <v-text-field
                        class="start-date-custom"
                        v-model="startDateFormated"
                        :error-messages="errors"
                        placeholder="dd/mm/yyyy"
                        label=""
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        outlined
                        :disabled="isDisablePending"
                        dense
                        v-bind="attrs"
                        v-on="on"
                        @blur="campaign.startDate = parseDate(startDateFormated)"
                      ></v-text-field>
                  </validation-provider>
                  </template>
                  <v-date-picker
                    v-model="campaign.startDate"
                    no-title
                    scrollable
                    :min="currentDate"
                    :max="campaign.endDate"
                    @input="$refs.startDate.save(campaign.startDate);"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="3" class="px-8 py-0">
                <p class="text-bold mb-1">Áp dụng tới ngày</p>
                <v-menu
                  ref="endDate"
                  v-model="endDate"
                  :close-on-content-click="false"
                  :return-value.sync="campaign.endDate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  :disabled="isDisableActive"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <validation-provider
                      v-slot="{ errors }"
                      :rules="{}"
                      name="Tới ngày">
                      <v-text-field
                        v-model="endDateFormated"
                        class="start-date-custom"
                        :error-messages="errors"
                        placeholder="dd/mm/yyyy"
                        label=""
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        :disabled="isDisableActive"
                        outlined
                        clearable
                        @click:clear="campaign.endDate = null"
                        dense
                        v-bind="attrs"
                        v-on="on"
                        @blur="campaign.endDate = parseDate(endDateFormated)"
                      ></v-text-field>
                    </validation-provider>
                  </template>
                  <v-date-picker
                    v-model="campaign.endDate"
                    no-title
                    scrollable
                    :min="minEndDate"
                    @input="$refs.endDate.save(campaign.endDate);"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="3" class="px-8 py-0 pt-0">
                <p class="text-bold mb-1">Ngân sách</p>
                <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  :rules="{ min_value: 0, max: 10, alpha_num: true }"
                  name="Ngân sách"
                >
                  <v-text-field
                    class="text-field text-field-number"
                    :error-messages="errors"
                    placeholder="Nhập số tiền ngân sách tối đa"
                    outlined
                    dense
                    type="number"
                    v-model="campaign.budget"
                    :disabled="isDisableActive"
                  ></v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3" class="px-8 py-0">
                <p class="text-bold mb-1">Hình thức áp dụng*</p>
                <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  :rules="{ required: true }"
                  name="Hình thức áp dụng"
                >
                  <v-select
                    class="text-field"
                    :error-messages="errors"
                    :clearable="true"
                    :items="campaignForms"
                    item-value="id"
                    item-text="name"
                    :aLight="'right'"
                    placeholder="Chọn hình thức áp dụng"
                    attach
                    outlined
                    dense
                    v-model="campaign.formOfApplication"
                    @change="onChangeCampaignForm"
                    :disabled="isDisablePending"
                    :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
                  ></v-select>
                </validation-provider>
              </v-col>
              <v-col cols="3" class="px-8 py-0">
                <div class="d-flex justify-space-between">
                  <p class="text-bold mb-1">Chọn mã*</p>
                  <a v-if="campaign.promotionCode" class="link-edit" style="color: #4C9AFF; font-style: italic;" target="_blank" :href="`/promotion/detail/${getIDPromotion()}`">
                    Xem chi tiết
                  </a>
                </div>
                <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  :rules="{ required: true }"
                  name="Mã"
                >
                  <v-autocomplete
                    class="text-field"
                    :error-messages="errors"
                    :clearable="true"
                    :items="promotions"
                    item-value="code"
                    item-text="code"
                    :aLight="'right'"
                    placeholder="Chọn mã"
                    attach
                    outlined
                    dense
                    :disabled="isDisablePending"
                    v-model="campaign.promotionCode"
                    :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
                  ></v-autocomplete>
                </validation-provider>
              </v-col>
              <v-col cols="3" class="px-8 py-0">
                <p class="text-bold mb-1">Loại chiến dịch*</p>
                <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  :rules="{ required: true }"
                  name="Loại chiến dịch"
                >
                  <v-select
                    class="text-field"
                    :error-messages="errors"
                    :clearable="true"
                    :items="campaignTypes"
                    item-value="id"
                    item-text="name"
                    :aLight="'right'"
                    placeholder="Chọn loại chiến dịch"
                    attach
                    outlined
                    dense
                    v-model="campaign.type"
                    :disabled="!!campaign.id"
                    @change="onChangeCampaignType"
                    :menu-props="{ bottom: true, offsetY: true, maxHeight: '200' }"
                  ></v-select>
                </validation-provider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3" class="px-8 py-0">
                <p class="text-bold mb-1">Tự động hiển thị cho người dùng*</p>
                <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  :rules="{ required: true }"
                  name="Tự động hiển thị cho người dùng"
                >
                  <v-select
                    class="text-field"
                    :error-messages="errors"
                    :clearable="true"
                    :items="autoDisplays"
                    item-value="id"
                    item-text="name"
                    :aLight="'right'"
                    placeholder="Chọn"
                    attach
                    outlined
                    dense
                    :disabled="isDisableActive"
                    v-model="campaign.autoDisplay"
                    :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
                  ></v-select>
                </validation-provider>
              </v-col>

              <v-col cols="3" class="px-8 py-0">
                <p class="text-bold mb-1">Giới hạn dùng trên đơn hàng*</p>
                <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  :rules="{ required: true }"
                  name="Giới hạn dùng trên đơn hàng"
                >
                  <v-select
                    class="text-field"
                    :error-messages="errors"
                    :clearable="true"
                    :items="orderLimits"
                    item-value="id"
                    item-text="name"
                    :aLight="'right'"
                    placeholder="Chọn"
                    attach
                    outlined
                    dense
                    @change="onChangeOrderLimit"
                    v-model="campaign.orderLimit"
                    :disabled="isDisableActive"
                    :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
                  ></v-select>
                </validation-provider>
              </v-col>
              <v-col cols="3" class="px-8 py-0">
                <p class="text-bold mb-1"> Nhóm giới hạn duy nhất</p>
                  <v-autocomplete
                    :clearable="true"
                    :aLight="'right'"
                    placeholder="Chọn"
                    attach
                    outlined
                    dense
                    multiple
                    v-model="campaign.campaignLimitUniqueGroups"
                    :items="groupLimitUniqueGroups"
                  >
                  </v-autocomplete>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="6" class="px-8 py-0 pb-4">
                <p class="text-bold mb-1">Nguồn chi phí*</p>
                <v-simple-table class="table-layout table-custom table-sku">
                  <thead>
                    <tr>
                      <th class="col-resouce-code">Nguồn chi phí</th>
                      <th class="col-resouce-name">%</th>
                      <th class="col-resouce-action text-center">Thao tác</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <v-select
                          class="text-field text-field-no-message"
                          :clearable="true"
                          :items="campaignBu"
                          item-value="code"
                          item-text="name"
                          :aLight="'right'"
                          placeholder="Chọn"
                          attach
                          outlined
                          dense
                          v-model="newBuCode"
                          :disabled="isDisablePending"
                          @change="newBuCodeError = false"
                          :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
                        ></v-select>
                        <div class="box-message">
                          <span class="text-red text-error" v-if="newBuCodeError">Chưa chọn nguồn chi phí</span>
                        </div>
                      </td>
                      <td>
                        <v-text-field
                          class="text-field text-field-no-message text-field-number"
                          placeholder="Nhập %"
                          outlined
                          dense
                          maxLength="3"
                          type="number"
                          :disabled="isDisablePending"
                          v-model="newValue"
                          @keyup="newValueRequiredError = false; newValueError = false"
                        ></v-text-field>
                        <div class="box-message">
                          <span class="text-red text-error" v-if="newValueRequiredError">Chưa điền %</span>
                          <span class="text-red text-error" v-if="newValueError">Giá trị phải lớn hơn 0 và nhỏ hơn 100</span>
                        </div>
                      </td>
                      <td class="text-center">
                        <v-tooltip bottom class="mr-2">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon color="#329D20" v-bind="attrs" v-on="on" @click="addSourceBudget" :disabled="isDisablePending">
                              mdi-plus-box
                            </v-icon>
                          </template>
                          <span>Thêm</span> 
                        </v-tooltip>
                        <!-- <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon color="#959595" v-bind="attrs" v-on="on" @click="removeSourceBudget(item, index)">
                              mdi-delete
                            </v-icon>
                          </template>
                          <span>Xóa</span>
                        </v-tooltip> -->
                      </td>
                    </tr>
                    <tr v-for="(item, index) in resourceBudgets" :key="index">
                      <td>
                        {{ campaignBuObj[item.buCode] }}
                      </td>
                      <td>
                        {{ item.value }} %
                      </td>
                      <td class="text-center">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon color="#959595" v-bind="attrs" v-on="on" @click="removeSourceBudget(item, index)" :disabled="isDisablePending">
                              mdi-delete
                            </v-icon>
                          </template>
                          <span>Xóa</span>
                        </v-tooltip>
                      </td>
                    </tr>
                    <tr v-if="resourceBudgets.length < 2" style="height: 150px;"></tr>
                  </tbody>
                </v-simple-table>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <DirectDiscount
          :readonly="readonly"
          v-if="[campaignTypePercentDiscount, campaignTypeDirectDiscount].includes(campaign.type)"
          :isDisablePending="isDisablePending"
          :isDisableActive="isDisableActive"
          :campaign="campaign"
          :applyForms="applyForms"
          :campaignBu="campaignBu"
          :typeOfProducts="typeOfProducts"
          :pnlCodes="pnlCodes"
          :categoryCodes="categoryCodes"
          :skus="skus"
        />
        <!-- <PercentDiscount v-if="campaign.type === campaignTypePercentDiscount" :campaign="campaign" /> -->
        <BuyXValueGiftY
          v-if="campaign.type === campaignTypeGift"
          :isDisablePending="isDisablePending"
          :isDisableActive="isDisableActive"
          :campaign="campaign"
          :typeOfProducts="typeOfProducts"
          :promotionCampaignConditionGiftByProduct="promotionCampaignConditionGiftByProduct"
          />
      </validation-observer>
      <BuyProductXGiftY
        :isDisablePending="isDisablePending"
        :isDisableActive="isDisableActive"
        v-if="campaign.type === campaignTypeBuyXGetY"
        :campaign="campaign"
        :typeOfProducts="typeOfProducts"
        :readonly="readonly"
        :giftProductsByBoughtProducts="giftProductsByBoughtProducts" />

      <!---->
      <!-- <v-col cols="12">
        <div class="group-form">
          <GeneralDiscountCodeList v-if="productAttributes && campaign.type === 'generalDiscoundCode'" :productAttributes="productAttributes" :data="listItems" />
        </div>
      </v-col> -->
    </div>
  </div>
</template>

<script>
import * as moment from 'moment';

import {
  campaignTypeDirectDiscount,
  campaignTypePercentDiscount,
  campaignTypeBuyXGetY,
  campaignTypeGift,
  campaignTypeOfApplicationOrder,
  campaignTypeOfApplicationSKU,
  campaignTypeOfApplicationCategory,
  campaignStatusCancel,
  campaignStatusInactive,
  campaignStatusPending,
  campaignStatusActive,
  campaignStatusFinished,
} from '../../helpers/constants';

import RepositoryFactory from '@/repositories/RepositoryFactory';
const CampaignRepository = RepositoryFactory.get('campaign');
const PromotionRepository = RepositoryFactory.get('promotion');

import DirectDiscount from './components/detail/DirectDiscount.vue';
// import PercentDiscount from './components/detail/PercentDiscount.vue';
import BuyProductXGiftY from './components/detail/BuyProductXGiftY.vue';
import BuyXValueGiftY from './components/detail/BuyXValueGiftY.vue';

// import GeneralDiscountCodeList from './components/detail/GeneralDiscountCodeList.vue';

import Campaign from './models/Campaign';

export default {
  name: 'detail',
  components: {
    // GeneralDiscountCodeList,
    DirectDiscount,
    // PercentDiscount,
    BuyProductXGiftY,
    BuyXValueGiftY,
  },
  props:{
  },
  data() {
    return {
      startDate: false,
      endDate: false,
      isCreateData: false,
      tab: 0,
      campaignTypes: [],
      campaign: new Campaign({}),
      campaignTypeDirectDiscount,
      campaignTypePercentDiscount,
      campaignTypeBuyXGetY,
      campaignTypeGift,
      statuses: [],
      listItems: [],
      productAttributes: null,
      categories: [],
      campaignId: null,
      curriculumsObj: {},
      curriculums: [],
      // currentDate: moment().add(1, "days").format('YYYY-MM-DD'),
      resourceBudgets: [],
      campaignForms: [],
      campaignBu: [],
      promotions: [],
      campaignTypeOfApplicationOrder,
      campaignTypeOfApplicationSKU,
      campaignTypeOfApplicationCategory,
      newBuCode: null,
      newValue: null,
      newBuCodeError: false,
      newValueRequiredError: false,
      newValueError: false,
      skus: [],
      categoryCodes: [],
      giftProductsByBoughtProducts: [],
      promotionCampaignConditionGiftByProduct: [],
      applyForms: [],
      campaignStatusCancel,
      campaignStatusInactive,
      campaignStatusPending,
      campaignStatusActive,
      campaignStatusFinished,
      isPending: false,
      statusObj: {},
      campaignBuObj: {},
      oldFormOfApplication: null,
      oldPromotionCode: null,
      pnlCodes: [],
      orderLimits: [],
      autoDisplays: [],
      typeOfProducts: [],
      autoDisplaysClone: [],
      groupLimitUniqueGroups: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    };
  },
  computed: {
    readonly() {
      return this.campaign?.id && this.campaign.status != this.campaignStatusPending;
    },
    minEndDate() {
      const currentDate = moment().format('YYYY-MM-DD');
      return moment(this.campaign.startDate).isAfter(currentDate) ? moment(this.campaign.startDate).format('YYYY-MM-DD') : currentDate
    },
    currentDate() {
      return moment().format('YYYY-MM-DD');
    },
    startDateFormated() {
      return this.formatDate(this.campaign.startDate);
    },
    endDateFormated() {
      return this.formatDate(this.campaign.endDate);
    },
    isDisablePending() {
      if (this.campaign.id && [this.campaignStatusInactive, this.campaignStatusFinished, this.campaignStatusActive].includes(this.campaign.status)) {
        return true;
      }

      return false;
    },
    isDisableActive() {
      if (this.campaign.id && [this.campaignStatusInactive, this.campaignStatusFinished].includes(this.campaign.status)) {
        return true;
      }

      return false;
    },
    canUpdate() {
      if (this.campaign.id && [this.campaignStatusPending, this.campaignStatusActive].includes(this.campaign.status)) {
        return true;
      }

      return false;
    },
  },
  async created() {
    this.getListAttributes();

    if (this.$route.params.id) {
      this.getDetail(this.$route.params.id);
      this.campaignId = parseInt(this.$route.params.id);
    }
  },
  mounted() {
    if (this.campaign && this.campaign.formOfApplication) {
      if (this.campaign.formOfApplication === 2) this.autoDisplays = this.autoDisplays.filter((item) => item.id === 0);
    }
  },
  beforeDestroy() {
  },
  watch: {
    'campaign.formOfApplication': {
      handler(val) {
        if (val === 2) {
          this.autoDisplays = this.autoDisplays.filter((item) => item.id === 0);
        } else {
          this.autoDisplays = _.cloneDeep(this.autoDisplaysClone);
        }
      },
      deep: true,
    },
  },
  methods: {
    async onChangeCampaignForm() {
      await this.getListPromotions();
      this.campaign.promotionCode = null;
      if (this.oldFormOfApplication && this.oldFormOfApplication === this.campaign.formOfApplication) {
        this.promotions.push({code: this.oldPromotionCode});
      }

      if (this.campaign.formOfApplication == 2) {
        this.campaign.autoDisplay = 0;
      }
    },
    addSourceBudget() {
      const isExistCode = this.resourceBudgets.find((item) => item.buCode === this.newBuCode);
      if (isExistCode) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi!',
          text: 'Nguồn đã thêm trước đó',
        });
      }
      if (!this.newBuCode) {
        this.newBuCodeError = true;
        return;
      }
      if (!this.newValue) {
        this.newValueRequiredError = true;
        return;
      }
      if (this.newValue && (parseInt(this.newValue) < 0 || parseInt(this.newValue) > 100) ) {
        this.newValueError = true;
        return;
      }
      this.resourceBudgets.push({
        buCode: this.newBuCode,
        value: parseInt(this.newValue),
      });
      this.newBuCode = null;
      this.newValue = null;
    },
    removeSourceBudget(item, index) {
      this.resourceBudgets.splice(index, 1);
    },
    compare(a, b) {
      if (b.id > a.id) {
        return 1;
      }
      if (a.id > b.id) {
        return -1;
      }
      return 0;
    },
    onChangeOrderLimit() {
      if (this.campaign.orderLimit === 1) {
        this.campaign.autoDisplay = 0;
      }

      if (this.campaign.orderLimit === 2) {
        if (this.campaign.formOfApplication != 2) {
          this.campaign.autoDisplay = 1;
        }
      }
    },
    onChangeCampaignType() {
      if ([1, 2].includes(this.campaign.type)) {
        this.campaign.autoDisplay = 0;
        // this.campaign.orderLimit = 1;
      }

      if ([3, 4].includes(this.campaign.type)) {
        if (this.campaign.formOfApplication != 2) {
          this.campaign.autoDisplay = 1;
        }
        // this.campaign.orderLimit = 2;
      }
      this.campaign.orderLimit = null;
    },
    async getListAttributes() {
      const res = await CampaignRepository.getOptions();
      this.campaignForms = res.data.applicableForm;
      this.statuses = res.data.status;
      this.statuses.forEach((item) => this.statusObj[item.id] = item.name);
      this.campaignTypes = res.data.type;
      this.campaignBu = res.data.campaignBu;
      res.data.campaignBu.forEach((item) => {
        this.campaignBuObj[item.code] = item.name;
      });
      // TODO
      res.data.applicableType.push({ id: 4, name: 'Theo Đơn vị (PnL)' });
      this.applyForms = res.data.applicableType;
      this.orderLimits = res.data.orderLimit;
      this.autoDisplays = res.data.autoDisplay;
      this.autoDisplaysClone = res.data.autoDisplay;
      this.typeOfProducts = res.data.productType;
    },
    async getDetail(id) {
      const res = await CampaignRepository.getDetail(id);
      this.campaign = new Campaign(res.data);
      this.oldFormOfApplication = this.campaign.formOfApplication;
      this.oldPromotionCode = this.campaign.promotionCode;
      await this.getListPromotions();
      this.promotions.push({
        code: res.data.promotionCode,
      });

      this.resourceBudgets = res.data.promotionCampaignBudgets;

      // Loại chiến dịch giảm giá trực tiếp | giảm giá theo %
      if ([this.campaignTypeDirectDiscount, this.campaignTypePercentDiscount].includes(res.data.type)) {
        this.campaign.minimumAmount = res.data.promotionCampaignConditionDirect.minimumAmount;
        // Loại hình áp dụng: theo sản phẩm SKU
        if (this.campaign.typeOfApplication === this.campaignTypeOfApplicationSKU) {
          this.skus = res.data.promotionCampaignConditionDirect.skus;
        }

        if (this.campaign.typeOfApplication === 4) {
          this.pnlCodes = res.data.promotionCampaignConditionDirect.pnlCodes.map((item) => {
            return {
              code: item,
              name: item,
            }
          });
        }

        // Loại hình áp dụng: theo danh mục
        if (this.campaign.typeOfApplication === this.campaignTypeOfApplicationCategory) {
          this.categoryCodes = res.data.promotionCampaignConditionDirect.categoryCodes.map((item) => {
            return {
              code: item,
            };
          });
        }
      }

      // Loại chiến dịch mua sp X tặng sp Y
      if (this.campaign.type === this.campaignTypeBuyXGetY) {
        this.giftProductsByBoughtProducts = res.data.promotionCampaignConditionGiftByAmount.giftProductsByBoughtProducts;
        this.campaign.minimumAmount = res.data.promotionCampaignConditionGiftByAmount.minimumAmount;
      }

      // Loại chiến dịch tặng quà
      if (this.campaign.type === this.campaignTypeGift) {
        this.promotionCampaignConditionGiftByProduct = res.data.promotionCampaignConditionGiftByProduct.giftProducts;
        this.campaign.minimumAmount = res.data.promotionCampaignConditionGiftByProduct.minimumAmount;
      }
    },
    cancel() {
      this.$swal
        .fire({
          title: "Cảnh báo",
          text: "Các thông tin đã nhập sẽ không được lưu lại",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Hủy",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Xác nhận",
        })
        .then( async (result) => {
          if (result?.value) {
            this.$router.push('/campaign');
          }
        });
    },
    async saveCampaign() {
      const isValid = await this.$refs.validator.validate();
      if (!isValid) {
        return;
      }
      if (!this.resourceBudgets.length) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi!',
          text: 'Chưa có nguồn chi phí',
        });
      }
      if (this.resourceBudgets.length) {
        const sumresourceBudget = this.resourceBudgets.reduce((acc, current) => {
          return current.value + acc;
        }, 0);

        if (sumresourceBudget != 100) {
          let msg = sumresourceBudget < 100
            ? 'Chi phí chưa phân bổ đủ 100%. Đề nghị kiểm tra lại.'
            : 'Chi phí phân phổ đang lớn hơn 100%. Đề nghị kiểm tra lại.';
          return this.$swal({
            type: 'error',
            title: 'Lỗi!',
            text: msg,
          });
        }
      }
      if ([2, 3, 4].includes(this.campaign.typeOfApplication) && !this.campaign.typeOfProduct ||(this.campaign.type === 3 && !this.campaign.typeOfProduct)) {
        return this.$swal({
            type: 'error',
            title: 'Lỗi!',
            text: 'Chưa chọn loại sản phẩm',
          });
      }
      if (!this.campaign._id) {
        const campaign = {
          title: this.campaign.title ? this.campaign.title.trim() : null,
          description: this.campaign.description ? this.campaign.description.trim() : null,
          startDate: moment(this.campaign.startDate).format('YYYY/MM/DD'),
          endDate: this.campaign.endDate ? moment(this.campaign.endDate).format('YYYY/MM/DD') : null,
          budget: this.campaign.budget || null,
          formOfApplication: this.campaign.formOfApplication,
          type: this.campaign.type,
          promotionCode: this.campaign.promotionCode,
          promotionDiscount: this.campaign.promotionDiscount,
          numberOfAvailableUser: this.campaign.numberOfAvailableUser || null,
          giftCode: this.campaign.giftCode,
          typeOfApplication: this.campaign.typeOfApplication,
          promotionCampaignBudgets: this.resourceBudgets,
          orderLimit: this.campaign.orderLimit,
          autoDisplay: this.campaign.autoDisplay,
          campaignLimitUniqueGroups: this.campaign.campaignLimitUniqueGroups,
        };
        if (this.campaign.typeOfProduct) {
          campaign.typeOfProduct = this.campaign.typeOfProduct;
        }
        // Loại chiến dịch giảm giá trực tiếp | giảm giá theo %
        if ([this.campaignTypeDirectDiscount, this.campaignTypePercentDiscount].includes(campaign.type)) {
          const promotionCampaignConditionDirect = {
            typeOfApplication: this.campaign.typeOfApplication,
            minimumAmount: this.campaign.minimumAmount,
          };

          if (campaign.type === this.campaignTypePercentDiscount) {
            campaign.numberOfAvailableOrder = this.campaign.numberOfAvailableOrder ? this.campaign.numberOfAvailableOrder : null;
          }
          // Loại hình áp dụng: theo đơn hàng
          // if (this.campaign.typeOfApplication === this.campaignTypeOfApplicationOrder) {
          //   // không làm gì
          // }

          // Loại hình áp dụng: theo sản phẩm SKU
          if (this.campaign.typeOfApplication === this.campaignTypeOfApplicationSKU) {
            if (!this.skus.length) {
              return this.$swal({
                type: 'error',
                title: 'Lỗi!',
                text: 'Chưa chọn SKU',
              });
            }
            promotionCampaignConditionDirect.skus = this.skus;
          }

          if (this.campaign.typeOfApplication === 4) {
            if (!this.pnlCodes.length) {
              return this.$swal({
                type: 'error',
                title: 'Lỗi!',
                text: 'Chưa chọn đơn vị (PnL)',
              });
            }
            promotionCampaignConditionDirect.pnlCodes = this.pnlCodes.map((item) => item.code);
          }

          // Loại hình áp dụng: theo danh mục
          if (this.campaign.typeOfApplication === this.campaignTypeOfApplicationCategory) {
            if (!this.categoryCodes.length) {
              return this.$swal({
                type: 'error',
                title: 'Lỗi!',
                text: 'Chưa chọn danh mục',
              });
            }
            promotionCampaignConditionDirect.categoryCodes = this.categoryCodes.map((item) => item.code);
          }

          campaign.promotionCampaignConditionDirect = promotionCampaignConditionDirect;
        }

        // Loại chiến dịch mua sp X tặng sp Y
        if (campaign.type === this.campaignTypeBuyXGetY) {
          if (this.campaign.numberOfAvailableUser && parseInt(this.campaign.numberOfAvailableUser) < 0) {
            return this.$swal({
              type: 'error',
              title: 'Lỗi!',
              text: 'Số lượt tối đa/user phải lớn hơn 0',
            });
          }
          if (this.campaign.numberOfAvailableUser && parseInt(this.campaign.numberOfAvailableUser) > 9999999999) {
            return this.$swal({
              type: 'error',
              title: 'Lỗi!',
              text: 'Số lượt tối đa/user phải nhỏ hơn 9999999999',
            });
          }
          if (this.campaign.minimumAmount && parseInt(this.campaign.minimumAmount) > 9999999999) {
            return this.$swal({
              type: 'error',
              title: 'Lỗi!',
              text: 'Giá trị đơn hàng tối thiểu phải nhỏ hơn 9999999999',
            });
          }
          if (this.campaign.minimumAmount === '') {
            return this.$swal({
              type: 'error',
              title: 'Lỗi!',
              text: 'Chưa nhập giá trị đơn hàng tối thiểu',
            });
          }

          if (this.campaign.minimumAmount && parseInt(this.campaign.minimumAmount) < 0) {
            return this.$swal({
              type: 'error',
              title: 'Lỗi!',
              text: 'Giá trị đơn hàng tối thiểu phải lớn hơn 0',
            });
          }
          if (!this.giftProductsByBoughtProducts.length) {
            return this.$swal({
              type: 'error',
              title: 'Lỗi!',
              text: 'Chưa có thông tin Mua Sản phẩm X tặng Sản phẩm Y',
            });
          }
          let flagGiftProductsByBoughtProducts = false;
          let flagQuantityGiftProductsByBoughtProducts = false;
          const giftProductsByBoughtProducts = this.giftProductsByBoughtProducts.map((item) => {
            const giftProducts = item.giftProducts.map((itemPC) => {
              if (!itemPC.productCode || !itemPC.quantity) {
                flagGiftProductsByBoughtProducts = true;
              }
              if (itemPC.quantity && parseInt(itemPC.quantity) < 0) {
                flagQuantityGiftProductsByBoughtProducts = true;
              }
              if (itemPC.quantity && parseInt(itemPC.quantity) > 9999999999) {
                flagQuantityGiftProductsByBoughtProducts = true;
              }
              return {
                productCode: itemPC.productCode,
                quantity: itemPC.quantity,
                skuType: itemPC.skuType,
              };
            });
            return {
              purchasedProductCode: item.purchasedProductCode,
              purchasedProductQuantity: item.purchasedProductQuantity,
              purchasedProductSkuType: item.purchasedProductSkuType,
              giftProducts,
            }
          });
          if (flagGiftProductsByBoughtProducts) {
            return this.$swal({
              type: 'error',
              title: 'Lỗi!',
              text: 'Chưa nhập đủ thông tin sản phẩm tặng',
            });
          }
          if (flagQuantityGiftProductsByBoughtProducts) {
            return this.$swal({
              type: 'error',
              title: 'Lỗi!',
              text: 'Số lượng tặng phải lớn hơn 0 và nhỏ hơn 9999999999',
            });
          }
          const promotionCampaignConditionGiftByAmount = {
            minimumAmount: this.campaign.minimumAmount,
            giftProductsByBoughtProducts
          };

          delete campaign.promotionDiscount;
          delete campaign.typeOfApplication;
          campaign.promotionCampaignConditionGiftByAmount = promotionCampaignConditionGiftByAmount;
        }

        // Loại chiến dịch tặng quà
        if (campaign.type === this.campaignTypeGift) {
          if (!this.promotionCampaignConditionGiftByProduct.length) {
            return this.$swal({
              type: 'error',
              title: 'Lỗi!',
              text: 'Chưa có sản phẩm tặng',
            });
          }
          const giftProducts = this.promotionCampaignConditionGiftByProduct.map((item) => {
            return {
              productCode: item.productCode,
              quantity: item.quantity,
              skuType: item.skuType,
            }
          })
          const promotionCampaignConditionGiftByProduct = {
            minimumAmount: this.campaign.minimumAmount,
            giftProducts,
          };

          delete campaign.promotionDiscount;
          delete campaign.typeOfApplication;
          campaign.promotionCampaignConditionGiftByProduct = promotionCampaignConditionGiftByProduct;
        }

        this.isPending = true;
        const res = await CampaignRepository.create(campaign);
        this.isPending = false;
        if (res.data && res.data.id) {
          this.$swal({
            icon: "success",
            toast: true,
            text: 'Tạo thành công',
            timer: 1500,
          });

          return this.$router.push({name: 'Campaign'});
        } else {
          this.$swal({
            icon: "error",
            toast: true,
            text: res.errors && res.errors.message ? res.errors.message : 'Có lỗi xảy ra',
            timer: 1500,
          });
        }
      }

      if (this.campaign._id) {
        const resourceBudgets = this.resourceBudgets.map((item) => {
          return {
            buCode: item.buCode,
            value: item.value,
          };
        });
        const campaign = {
          title: this.campaign.title ? this.campaign.title.trim() : null,
          description: this.campaign.description ? this.campaign.description.trim() : null,
          startDate: moment(this.campaign.startDate).format('YYYY/MM/DD'),
          endDate: this.campaign.endDate ? moment(this.campaign.endDate).format('YYYY/MM/DD') : null,
          budget: this.campaign.budget || null,
          formOfApplication: this.campaign.formOfApplication,
          type: this.campaign.type,
          promotionCode: this.campaign.promotionCode,
          promotionDiscount: this.campaign.promotionDiscount,
          numberOfAvailableUser: this.campaign.numberOfAvailableUser || null,
          giftCode: this.campaign.giftCode,
          typeOfApplication: this.campaign.typeOfApplication,
          promotionCampaignBudgets: resourceBudgets,
          orderLimit: this.campaign.orderLimit,
          autoDisplay: this.campaign.autoDisplay,
          campaignLimitUniqueGroups: this.campaign.campaignLimitUniqueGroups,
        };

        if (this.campaign.typeOfProduct) {
          campaign.typeOfProduct = this.campaign.typeOfProduct;
        }

        // Loại chiến dịch giảm giá trực tiếp | giảm giá theo %
        if ([this.campaignTypeDirectDiscount, this.campaignTypePercentDiscount].includes(campaign.type)) {
          const promotionCampaignConditionDirect = {
            typeOfApplication: this.campaign.typeOfApplication,
            minimumAmount: this.campaign.minimumAmount,
          };

          if (campaign.type === this.campaignTypePercentDiscount) {
            campaign.numberOfAvailableOrder = this.campaign.numberOfAvailableOrder ? this.campaign.numberOfAvailableOrder : null;
          }
          // Loại hình áp dụng: theo đơn hàng
          // if (this.campaign.typeOfApplication === this.campaignTypeOfApplicationOrder) {
          //   // không làm gì
          // }

          // Loại hình áp dụng: theo sản phẩm SKU
          if (this.campaign.typeOfApplication === this.campaignTypeOfApplicationSKU) {
            if (!this.skus.length) {
              return this.$swal({
                type: 'error',
                title: 'Lỗi!',
                text: 'Chưa chọn SKU',
              });
            }
            promotionCampaignConditionDirect.skus = this.skus;
          }

          // Loại hình áp dụng: theo danh mục
          if (this.campaign.typeOfApplication === this.campaignTypeOfApplicationCategory) {
            if (!this.categoryCodes.length) {
              return this.$swal({
                type: 'error',
                title: 'Lỗi!',
                text: 'Chưa chọn danh mục',
              });
            }
            promotionCampaignConditionDirect.categoryCodes = this.categoryCodes.map((item) => item.code);
          }

          if (this.campaign.typeOfApplication === 4) {
            if (!this.pnlCodes.length) {
              return this.$swal({
                type: 'error',
                title: 'Lỗi!',
                text: 'Chưa chọn đơn vị (PnL)',
              });
            }
            promotionCampaignConditionDirect.pnlCodes = this.pnlCodes.map((item) => item.code);
          }

          campaign.promotionCampaignConditionDirect = promotionCampaignConditionDirect;
        }

        // Loại chiến dịch mua sp X tặng sp Y
        if (campaign.type === this.campaignTypeBuyXGetY) {
          if (this.campaign.numberOfAvailableUser && parseInt(this.campaign.numberOfAvailableUser) < 0) {
            return this.$swal({
              type: 'error',
              title: 'Lỗi!',
              text: 'Số lượt tối đa/user phải lớn hơn 0',
            });
          }
          if (this.campaign.numberOfAvailableUser && parseInt(this.campaign.numberOfAvailableUser) > 9999999999) {
            return this.$swal({
              type: 'error',
              title: 'Lỗi!',
              text: 'Số lượt tối đa/user phải nhỏ hơn 9999999999',
            });
          }
          if (this.campaign.minimumAmount && parseInt(this.campaign.minimumAmount) > 9999999999) {
            return this.$swal({
              type: 'error',
              title: 'Lỗi!',
              text: 'Giá trị đơn hàng tối thiểu phải nhỏ hơn 9999999999',
            });
          }
          if (this.campaign.minimumAmount === '') {
            return this.$swal({
              type: 'error',
              title: 'Lỗi!',
              text: 'Chưa nhập giá trị đơn hàng tối thiểu',
            });
          }

          if (this.campaign.minimumAmount && parseInt(this.campaign.minimumAmount) < 0) {
            return this.$swal({
              type: 'error',
              title: 'Lỗi!',
              text: 'Giá trị đơn hàng tối thiểu phải lớn hơn 0',
            });
          }
          if (!this.giftProductsByBoughtProducts.length) {
            return this.$swal({
              type: 'error',
              title: 'Lỗi!',
              text: 'Chưa có thông tin Mua Sản phẩm X tặng Sản phẩm Y',
            });
          }
          let flagGiftProductsByBoughtProducts = false;
          let flagQuantityGiftProductsByBoughtProducts = false;
          const giftProductsByBoughtProducts = this.giftProductsByBoughtProducts.map((item) => {
            const giftProducts = item.giftProducts.map((itemPC) => {
              if (!itemPC.productCode || !itemPC.quantity) {
                flagGiftProductsByBoughtProducts = true;
              }
              if (itemPC.quantity && parseInt(itemPC.quantity) < 0) {
                flagQuantityGiftProductsByBoughtProducts = true;
              }
              if (itemPC.quantity && parseInt(itemPC.quantity) > 9999999999) {
                flagQuantityGiftProductsByBoughtProducts = true;
              }
              return {
                productCode: itemPC.productCode,
                quantity: itemPC.quantity,
                skuType: itemPC.skuType,
              };
            });
            return {
              purchasedProductCode: item.purchasedProductCode,
              purchasedProductQuantity: item.purchasedProductQuantity,
              purchasedProductSkuType: item.purchasedProductSkuType,
              giftProducts,
            }
          });
          if (flagGiftProductsByBoughtProducts) {
            return this.$swal({
              type: 'error',
              title: 'Lỗi!',
              text: 'Chưa nhập đủ thông tin sản phẩm tặng',
            });
          }
          if (flagQuantityGiftProductsByBoughtProducts) {
            return this.$swal({
              type: 'error',
              title: 'Lỗi!',
              text: 'Số lượng tặng phải lớn hơn 0 và nhỏ hơn 9999999999',
            });
          }
          const promotionCampaignConditionGiftByAmount = {
            minimumAmount: this.campaign.minimumAmount,
            giftProductsByBoughtProducts
          };

          delete campaign.promotionDiscount;
          delete campaign.typeOfApplication;
          campaign.promotionCampaignConditionGiftByAmount = promotionCampaignConditionGiftByAmount;
        }

        // Loại chiến dịch tặng quà
        if (campaign.type === this.campaignTypeGift) {
          if (!this.promotionCampaignConditionGiftByProduct.length) {
            return this.$swal({
              type: 'error',
              title: 'Lỗi!',
              text: 'Chưa có sản phẩm tặng',
            });
          }
          const giftProducts = this.promotionCampaignConditionGiftByProduct.map((item) => {
            return {
              productCode: item.productCode,
              quantity: item.quantity,
              skuType: item.skuType,
            }
          })
          const promotionCampaignConditionGiftByProduct = {
            minimumAmount: this.campaign.minimumAmount,
            giftProducts,
          };

          delete campaign.promotionDiscount;
          delete campaign.typeOfApplication;
          campaign.promotionCampaignConditionGiftByProduct = promotionCampaignConditionGiftByProduct;
        }

        this.isPending = true;
        const res = await CampaignRepository.update(this.campaign.id, campaign);
        this.isPending = false;
        if (res.data && res.data.id) {
          this.$swal({
            icon: "success",
            toast: true,
            text: 'Cập nhật thành công',
            timer: 1500,
          });

          return this.$router.push({name: 'Campaign'});
        } else {
          this.$swal({
            icon: "error",
            toast: true,
            text: res.errors && res.errors.message ? res.errors.message : 'Có lỗi xảy ra',
            timer: 1500,
          });
        }
      }
    },
    async getListPromotions() {
      const params = {
        page: 1,
        limit: 99999,
        formOfApplication: this.campaign.formOfApplication,
      }
      const res = await PromotionRepository.getListActive(params);
      this.promotions = res.data;
    },
    approveCampaign() {
      this.$swal
        .fire({
          title: "Cảnh báo",
          text: "Các thông tin sẽ được cập nhật mới. Chiến dịch sẽ chuyển sang trạng thái hoạt động và có thể áp dụng lên đơn hàng. Hãy kiểm tra thật kỹ!",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Hủy",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Xác nhận",
        })
        .then( async (result) => {
          if (result?.value) {
            const isValid = await this.$refs.validator.validate();
            if (!isValid) {
              return;
            }
            if (!this.resourceBudgets.length) {
              return this.$swal({
                type: 'error',
                title: 'Lỗi!',
                text: 'Chưa có nguồn chi phí',
              });
            }
            if (this.resourceBudgets.length) {
              const sumresourceBudget = this.resourceBudgets.reduce((acc, current) => {
                return current.value + acc;
              }, 0);

              if (sumresourceBudget != 100) {
                let msg = sumresourceBudget < 100
                  ? 'Chi phí chưa phân bổ đủ 100%. Đề nghị kiểm tra lại.'
                  : 'Chi phí phân phổ đang lớn hơn 100%. Đề nghị kiểm tra lại.';
                return this.$swal({
                  type: 'error',
                  title: 'Lỗi!',
                  text: msg,
                });
              }
            }
            const resourceBudgets = this.resourceBudgets.map((item) => {
              return {
                buCode: item.buCode,
                value: item.value,
              };
            });
            const campaign = {
              title: this.campaign.title ? this.campaign.title.trim() : null,
              description: this.campaign.description ? this.campaign.description.trim() : null,
              startDate: moment(this.campaign.startDate).format('YYYY/MM/DD'),
              endDate: this.campaign.endDate ? moment(this.campaign.endDate).format('YYYY/MM/DD') : null,
              budget: this.campaign.budget || null,
              formOfApplication: this.campaign.formOfApplication,
              type: this.campaign.type,
              promotionCode: this.campaign.promotionCode,
              promotionDiscount: this.campaign.promotionDiscount,
              numberOfAvailableUser: this.campaign.numberOfAvailableUser || null,
              giftCode: this.campaign.giftCode,
              typeOfApplication: this.campaign.typeOfApplication,
              promotionCampaignBudgets: resourceBudgets,
              orderLimit: this.campaign.orderLimit,
              autoDisplay: this.campaign.autoDisplay,
              campaignLimitUniqueGroups: this.campaign.campaignLimitUniqueGroups,
            };

            if (this.campaign.typeOfProduct) {
              campaign.typeOfProduct = this.campaign.typeOfProduct;
            }

            // Loại chiến dịch giảm giá trực tiếp | giảm giá theo %
            if ([this.campaignTypeDirectDiscount, this.campaignTypePercentDiscount].includes(campaign.type)) {
              const promotionCampaignConditionDirect = {
                typeOfApplication: this.campaign.typeOfApplication,
                minimumAmount: this.campaign.minimumAmount,
              };

              if (campaign.type === this.campaignTypePercentDiscount) {
                campaign.numberOfAvailableOrder = this.campaign.numberOfAvailableOrder ? this.campaign.numberOfAvailableOrder : null;
              }
              // Loại hình áp dụng: theo đơn hàng
              // if (this.campaign.typeOfApplication === this.campaignTypeOfApplicationOrder) {
              //   // không làm gì
              // }

              // Loại hình áp dụng: theo sản phẩm SKU
              if (this.campaign.typeOfApplication === this.campaignTypeOfApplicationSKU) {
                if (!this.skus.length) {
                  return this.$swal({
                    type: 'error',
                    title: 'Lỗi!',
                    text: 'Chưa chọn SKU',
                  });
                }
                promotionCampaignConditionDirect.skus = this.skus;
              }

              // Loại hình áp dụng: theo danh mục
              if (this.campaign.typeOfApplication === this.campaignTypeOfApplicationCategory) {
                if (!this.categoryCodes.length) {
                  return this.$swal({
                    type: 'error',
                    title: 'Lỗi!',
                    text: 'Chưa chọn danh mục',
                  });
                }
                promotionCampaignConditionDirect.categoryCodes = this.categoryCodes.map((item) => item.code);
              }

              if (this.campaign.typeOfApplication === 4) {
                if (!this.pnlCodes.length) {
                  return this.$swal({
                    type: 'error',
                    title: 'Lỗi!',
                    text: 'Chưa chọn đơn vị (PnL)',
                  });
                }
                promotionCampaignConditionDirect.pnlCodes = this.pnlCodes.map((item) => item.code);
              }

              campaign.promotionCampaignConditionDirect = promotionCampaignConditionDirect;
            }

            // Loại chiến dịch mua sp X tặng sp Y
            if (campaign.type === this.campaignTypeBuyXGetY) {
              if (this.campaign.numberOfAvailableUser && parseInt(this.campaign.numberOfAvailableUser) < 0) {
                return this.$swal({
                  type: 'error',
                  title: 'Lỗi!',
                  text: 'Số lượt tối đa/user phải lớn hơn 0',
                });
              }
              if (this.campaign.numberOfAvailableUser && parseInt(this.campaign.numberOfAvailableUser) > 9999999999) {
                return this.$swal({
                  type: 'error',
                  title: 'Lỗi!',
                  text: 'Số lượt tối đa/user phải nhỏ hơn 9999999999',
                });
              }
              if (this.campaign.minimumAmount && parseInt(this.campaign.minimumAmount) > 9999999999) {
                return this.$swal({
                  type: 'error',
                  title: 'Lỗi!',
                  text: 'Giá trị đơn hàng tối thiểu phải nhỏ hơn 9999999999',
                });
              }
              if (this.campaign.minimumAmount === '') {
                return this.$swal({
                  type: 'error',
                  title: 'Lỗi!',
                  text: 'Chưa nhập giá trị đơn hàng tối thiểu',
                });
              }

              if (this.campaign.minimumAmount && parseInt(this.campaign.minimumAmount) < 0) {
                return this.$swal({
                  type: 'error',
                  title: 'Lỗi!',
                  text: 'Giá trị đơn hàng tối thiểu phải lớn hơn 0',
                });
              }
              if (!this.giftProductsByBoughtProducts.length) {
                return this.$swal({
                  type: 'error',
                  title: 'Lỗi!',
                  text: 'Chưa có thông tin Mua Sản phẩm X tặng Sản phẩm Y',
                });
              }
              let flagGiftProductsByBoughtProducts = false;
              let flagQuantityGiftProductsByBoughtProducts = false;
              const giftProductsByBoughtProducts = this.giftProductsByBoughtProducts.map((item) => {
                const giftProducts = item.giftProducts.map((itemPC) => {
                  if (!itemPC.productCode || !itemPC.quantity) {
                    flagGiftProductsByBoughtProducts = true;
                  }
                  if (itemPC.quantity && parseInt(itemPC.quantity) < 0) {
                    flagQuantityGiftProductsByBoughtProducts = true;
                  }
                  if (itemPC.quantity && parseInt(itemPC.quantity) > 9999999999) {
                    flagQuantityGiftProductsByBoughtProducts = true;
                  }
                  return {
                    productCode: itemPC.productCode,
                    quantity: itemPC.quantity,
                    skuType: itemPC.skuType,
                  };
                });
                return {
                  purchasedProductCode: item.purchasedProductCode,
                  purchasedProductQuantity: item.purchasedProductQuantity,
                  purchasedProductSkuType: item.purchasedProductSkuType,
                  giftProducts,
                }
              });

              if (flagGiftProductsByBoughtProducts) {
                return this.$swal({
                  type: 'error',
                  title: 'Lỗi!',
                  text: 'Chưa nhập đủ thông tin sản phẩm tặng',
                });
              }
              if (flagQuantityGiftProductsByBoughtProducts) {
                return this.$swal({
                  type: 'error',
                  title: 'Lỗi!',
                  text: 'Số lượng tặng phải lớn hơn 0 và nhỏ hơn 9999999999',
                });
              }
              const promotionCampaignConditionGiftByAmount = {
                minimumAmount: this.campaign.minimumAmount,
                giftProductsByBoughtProducts
              };

              delete campaign.promotionDiscount;
              delete campaign.typeOfApplication;
              campaign.promotionCampaignConditionGiftByAmount = promotionCampaignConditionGiftByAmount;
            }

            // Loại chiến dịch tặng quà
            if (campaign.type === this.campaignTypeGift) {
              if (!this.promotionCampaignConditionGiftByProduct.length) {
                return this.$swal({
                  type: 'error',
                  title: 'Lỗi!',
                  text: 'Chưa có sản phẩm tặng',
                });
              }
              const giftProducts = this.promotionCampaignConditionGiftByProduct.map((item) => {
                return {
                  productCode: item.productCode,
                  quantity: item.quantity,
                  skuType: item.skuType,
                }
              })
              const promotionCampaignConditionGiftByProduct = {
                minimumAmount: this.campaign.minimumAmount,
                giftProducts,
              };

              delete campaign.promotionDiscount;
              delete campaign.typeOfApplication;
              campaign.promotionCampaignConditionGiftByProduct = promotionCampaignConditionGiftByProduct;
            }
            campaign.status = this.campaignStatusActive;
            this.isPending = true;
            const res = await CampaignRepository.updateStatus(this.campaign.id, campaign);
            this.isPending = false;
            if (res.data && res.data.id) {
              this.$swal({
                icon: "success",
                toast: true,
                text: 'Duyệt chiến dịch thành công',
                timer: 1500,
              });
              return this.$router.push('/campaign');
            }

            this.$swal({
              icon: "error",
              toast: true,
              text: res.errors && res.errors.message ? res.errors.message : 'Có lỗi xảy ra',
              timer: 1500,
            });
          }
        });
    },
    cancelCampaign() {
      this.$swal
        .fire({
          title: 'Cảnh báo',
          text: "Chiến dịch sẽ bị hủy và không thể duyệt",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Hủy",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Xác nhận",
        })
        .then( async (result) => {
          if (result?.value) {
            this.isPending = true;
            const res = await CampaignRepository.updateStatus(this.campaign.id, { status: this.campaignStatusCancel });
            this.isPending = false;
            if (res.data && res.data.id) {
              this.$swal({
                icon: "success",
                toast: true,
                text: 'Hủy chiến dịch thành công',
                timer: 1500,
              });
              return this.$router.push('/campaign');
            }

            this.$swal({
              icon: "error",
              toast: true,
              text: res.errors && res.errors.message ? res.errors.message : 'Có lỗi xảy ra',
              timer: 1500,
            });
          }
        });
    },
    stopCampaign() {
      this.$swal
        .fire({
          title: "Cảnh báo",
          text: "Chiến dịch sau khi ngừng hoạt động sẽ không thể hoạt động lại!",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Hủy",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Xác nhận",
        })
        .then( async (result) => {
          if (result?.value) {
            this.isPending = true;
            const res = await CampaignRepository.updateStatus(this.campaign.id, { status: this.campaignStatusInactive });
            this.isPending = false;
            if (res.data && res.data.id) {
              this.$swal({
                icon: "success",
                toast: true,
                text: 'Ngừng hoạt động chiến dịch thành công',
                timer: 1500,
              });
              return this.$router.push('/campaign');
            }

            this.$swal({
              icon: "error",
              toast: true,
              text: res.errors && res.errors.message ? res.errors.message : 'Có lỗi xảy ra',
              timer: 1500,
            });
          }
        });
    },
    getIDPromotion() {
      if (this.campaign && this.campaign.id && this.campaign.promotion.id) {
        return this.campaign.promotion.id
      } else {
        const promotion = this.promotions.find((item) => item.code === this.campaign.promotionCode);
        return promotion ? promotion.id : null;
      }
    }
  }
};
</script>
<style scoped lang="scss">
  .text-error {
    font-size: 12px;
  }
  .btn-save {
    background: #8465FF !important;
    color: #fff;
  }

  .btn-red {
    background: #D30000 !important;
  }
  .btn-green {
    background: #1AB500 !important;
  }
  .btn-cancel  {
    background: #787878 !important;
    color: #fff;
  }
  .create-form {
    background: #fff;
  }
  .text-bold {
    font-weight: bold;
  }

  .btn-info {
    background: #6587FF !important;
    color: #fff;
  }

  .icon-search {
    left: 40px;
    position: relative;
  }
  .table-custom {
    th {
      background: #E7E8FF;
      border-left: 1px solid #fff;
    }
  }
  .col-resouce-code {
    width: 200px;
  }
  .col-resouce-name {
    // width: ;
  }
  .col-resouce-action {
    // width: ;
  }
</style>

<style lang="scss">
  .group-form {
    background: #FAFBFF;
    border-radius: 10px;
    box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25);
  }
  .text-field fieldset {
    background: #fff !important;
  }
  .text-search {
    .v-input__slot {
      min-height: 20px !important;
      padding-left: 35px !important;
    }
  }

  .v-select-custom {
    .v-subheader {
      font-weight: bold;
      background: #ECECEC;
      color: #000;
    }
  }

  .group-bread-scrumb {
    position: relative;
    top: -30px;
    z-index: 99;
    height: 0;
    font-weight: bold;
    font-size: 17px;
    a {
      text-decoration: none !important;
      color: #000;
    }
  }
  .start-date-custom {
    .v-input__slot {
      background: #fff !important;
    }
  }
  .text-field-no-message {
    .v-text-field__details {
      display: none !important;
    }
  }

  .text-red {
    color: red;
  }

  .box-message {
    height: 10px;
  }
</style>
